import { useState } from "react";
import { coachPaths } from "../../routes/coach";
import AuthLayout from "../../layouts/AuthLayout";
import StepsDots from "../../components/form/StepsDots";
import useAppNavigate from "../../components/hooks/useAppNavigate";

const Signup = () => {
  const { goTo } = useAppNavigate();
  const [signupType, setSignUpType] = useState("");
  const options = [
    {
      icon: (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0173 0.0835443C19.2307 0.118404 19.4231 0.232648 19.5558 0.403373C19.6886 0.574098 19.7519 0.788685 19.733 1.00412L19.7249 1.06754C19.3454 3.39183 18.841 5.3044 18.2116 6.80526C17.6402 8.16726 16.6716 9.77683 15.3059 11.634L14.9707 12.0844L14.7972 12.3133C14.2657 13.0106 13.9391 13.8423 13.8543 14.715C13.7354 15.9427 13.4736 16.8214 13.0687 17.3511C11.6059 18.9634 10.2467 20.0161 8.99131 20.5093C8.92352 20.5359 8.85006 20.5448 8.77788 20.5351C8.7057 20.5255 8.63716 20.4976 8.57875 20.4541C8.52033 20.4106 8.47396 20.353 8.44402 20.2866C8.41407 20.2202 8.40153 20.1473 8.40759 20.0747L8.73545 16.1425C8.74031 16.0844 8.73325 16.0259 8.71471 15.9706C8.69617 15.9153 8.66653 15.8643 8.62761 15.8209C8.58869 15.7774 8.54131 15.7424 8.48837 15.7179C8.43543 15.6934 8.37805 15.6799 8.31973 15.6784L8.27002 15.6801C7.58773 15.7415 6.90159 15.4701 6.21159 14.8658C5.60388 14.3338 5.28231 13.7974 5.24688 13.2565L5.24345 13.161C5.24326 13.0952 5.22794 13.0303 5.19865 12.9714C5.16936 12.9125 5.1269 12.8611 5.07456 12.8212C5.02222 12.7814 4.96141 12.7541 4.89683 12.7415C4.83225 12.7289 4.76564 12.7314 4.70216 12.7487L1.50202 13.6213C1.42797 13.6414 1.34987 13.6413 1.27588 13.621C1.20188 13.6006 1.13471 13.5608 1.08137 13.5056C1.02803 13.4504 0.990491 13.3819 0.972663 13.3073C0.954835 13.2326 0.957376 13.1546 0.98002 13.0813L0.997163 13.0341L1.16816 12.6527L1.33402 12.2888L1.49516 11.943L1.65159 11.6151L1.80373 11.3048L1.87788 11.1565L2.02231 10.8733L2.16245 10.6075L2.23102 10.4815L2.36388 10.2433L2.49245 10.0225C2.55531 9.91683 2.61645 9.81769 2.67588 9.72512L2.79245 9.5494C2.94473 9.32654 3.08445 9.15154 3.21159 9.0244C3.68559 8.55012 4.61173 8.11269 5.99002 7.71212C6.70733 7.50359 7.35768 7.11119 7.87659 6.57383C8.00516 6.4404 8.13259 6.30983 8.25888 6.18212L8.63345 5.80669C8.92905 5.51356 9.22937 5.22523 9.53431 4.94183L9.88102 4.62469L10.2196 4.32469C11.1116 3.5464 11.9184 2.94569 12.6402 2.52254C13.0279 2.2954 13.4787 2.06397 13.9927 1.82826L14.3446 1.67054L14.5276 1.59126L14.9077 1.43183C15.0374 1.3784 15.1703 1.32483 15.3063 1.27112L15.7242 1.10912L16.16 0.946259L16.6152 0.781687L17.0887 0.616259L17.5807 0.449116L17.8336 0.365544L18.3543 0.196687L18.6213 0.11183C18.7493 0.0715404 18.8849 0.061852 19.0173 0.0835443ZM4.92588 14.7137C5.08331 14.7143 5.23588 14.7305 5.38359 14.7625C5.04645 14.9257 4.83302 15.4963 4.74331 16.4743L4.73259 16.6041C4.72778 16.666 4.73648 16.7282 4.75808 16.7864C4.77967 16.8446 4.81366 16.8974 4.85767 16.9412C4.90169 16.985 4.9547 17.0187 5.01302 17.0399C5.07134 17.0612 5.13358 17.0696 5.19545 17.0644C6.24373 16.9758 6.85202 16.7548 7.02031 16.4014C7.05231 16.5485 7.06845 16.7003 7.06873 16.8565C7.06873 17.6451 6.49731 18.2165 5.35445 18.5708L3.50859 18.7568C3.44568 18.7632 3.38214 18.7555 3.32253 18.7344C3.26293 18.7133 3.20873 18.6792 3.16384 18.6347C3.11894 18.5902 3.08445 18.5363 3.06285 18.4768C3.04124 18.4174 3.03306 18.3539 3.03888 18.291L3.21159 16.428C3.56559 15.2851 4.13702 14.7137 4.92588 14.7137ZM13.7116 4.85654C13.2001 4.85654 12.7096 5.05973 12.3479 5.42141C11.9862 5.78309 11.783 6.27363 11.783 6.78512C11.783 7.2966 11.9862 7.78714 12.3479 8.14882C12.7096 8.5105 13.2001 8.71369 13.7116 8.71369C14.2231 8.71369 14.7136 8.5105 15.0753 8.14882C15.437 7.78714 15.6402 7.2966 15.6402 6.78512C15.6402 6.27363 15.437 5.78309 15.0753 5.42141C14.7136 5.05973 14.2231 4.85654 13.7116 4.85654Z"
            fill="#023047"
          />
        </svg>
      ),
      label: "Find a Job",
      description: "Discover curated opportunities tailored to your skills.",
    },
    {
      icon: (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 7C9.10457 7 10 6.10457 10 5C10 3.89543 9.10457 3 8 3C6.89543 3 6 3.89543 6 5C6 6.10457 6.89543 7 8 7Z"
            fill="#023047"
            stroke="#023047"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17 7C18.1046 7 19 6.10457 19 5C19 3.89543 18.1046 3 17 3C15.8954 3 15 3.89543 15 5C15 6.10457 15.8954 7 17 7Z"
            fill="#023047"
            stroke="#023047"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.5 10H10.5L9.5 21H6.5L5.5 10ZM14.5 10H19.5L18.5 21H15.5L14.5 10Z"
            fill="#023047"
            stroke="#023047"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      label: "Hire Talent",
      description: "Connect with elite freelancers for your business needs.",
    },
    {
      icon: (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1354_14050)">
            <path
              d="M8.987 14.8866C9.377 14.8866 9.693 15.2006 9.693 15.5866C9.69261 15.6789 9.67403 15.7703 9.63834 15.8554C9.60265 15.9405 9.55054 16.0178 9.48498 16.0828C9.41942 16.1478 9.3417 16.1993 9.25626 16.2342C9.17081 16.2692 9.07932 16.287 8.987 16.2866H6.132C6.0396 16.2871 5.948 16.2694 5.86244 16.2345C5.77688 16.1996 5.69904 16.1482 5.63338 16.0832C5.56771 16.0182 5.51551 15.9408 5.47975 15.8556C5.444 15.7704 5.42539 15.679 5.425 15.5866C5.425 15.2006 5.742 14.8866 6.132 14.8866H8.987ZM9.677 12.2936C10.067 12.2936 10.383 12.6086 10.383 12.9936C10.3826 13.086 10.364 13.1774 10.3282 13.2626C10.2925 13.3478 10.2403 13.4252 10.1746 13.4902C10.109 13.5552 10.0311 13.6066 9.94556 13.6415C9.86 13.6764 9.7684 13.6941 9.676 13.6936H6.148C6.05568 13.694 5.96419 13.6762 5.87874 13.6412C5.7933 13.6063 5.71558 13.5548 5.65002 13.4898C5.58447 13.4248 5.53235 13.3476 5.49666 13.2624C5.46097 13.1773 5.44239 13.0859 5.442 12.9936C5.442 12.6076 5.758 12.2936 6.148 12.2936H9.677ZM13.541 8.83361C13.5439 8.27452 13.7686 7.73945 14.1657 7.34589C14.5628 6.95234 15.0999 6.73248 15.659 6.73461C16.2183 6.73248 16.7555 6.95248 17.1526 7.34625C17.5498 7.74002 17.7744 8.27535 17.777 8.83461C17.7738 9.39398 17.5492 9.92931 17.1522 10.3234C16.7553 10.7176 16.2184 10.9384 15.659 10.9376C15.0995 10.9381 14.5626 10.7171 14.1657 10.3228C13.7688 9.92851 13.5442 9.39307 13.541 8.83361ZM19.8 15.3926C19.9 16.0116 19.422 16.5726 18.795 16.5706H12.523C12.3757 16.5709 12.2301 16.5392 12.0963 16.4776C11.9625 16.416 11.8437 16.3261 11.7481 16.214C11.6525 16.102 11.5824 15.9705 11.5427 15.8286C11.5029 15.6868 11.4945 15.538 11.518 15.3926C11.833 13.4506 12.909 11.8836 14.314 11.2626C14.7254 11.4911 15.1883 11.6111 15.659 11.6111C16.1297 11.6111 16.5926 11.4911 17.004 11.2626C18.409 11.8836 19.486 13.4526 19.8 15.3926ZM11.088 11.1026C2.708 11.1026 10.941 11.1006 6.147 11.1006C6.0546 11.1011 5.963 11.0834 5.87744 11.0485C5.79188 11.0136 5.71404 10.9622 5.64838 10.8972C5.58271 10.8322 5.53051 10.7548 5.49475 10.6696C5.459 10.5844 5.44039 10.493 5.44 10.4006C5.44 10.0146 5.757 9.70061 6.147 9.70061L11.088 9.70161C11.478 9.70161 11.795 10.0156 11.794 10.4026C11.794 10.495 11.7757 10.5866 11.7401 10.6719C11.7046 10.7572 11.6525 10.8346 11.5869 10.8997C11.5212 10.9648 11.4433 11.0162 11.3577 11.0511C11.2721 11.0859 11.1804 11.1034 11.088 11.1026ZM6.148 8.50861C6.05549 8.50953 5.96371 8.49211 5.87797 8.45735C5.79223 8.42258 5.71424 8.37117 5.64849 8.30608C5.58275 8.24098 5.53056 8.1635 5.49495 8.07811C5.45933 7.99273 5.441 7.90113 5.441 7.80861C5.441 7.42261 5.758 7.10861 6.148 7.10861H11.088C11.477 7.10861 11.793 7.42161 11.793 7.80861C11.7919 7.99488 11.717 8.17312 11.5846 8.30418C11.4523 8.43524 11.2733 8.50841 11.087 8.50761L6.148 8.50861ZM13.957 18.6256C14.131 18.6256 14.298 18.5569 14.4216 18.4344C14.5452 18.3119 14.6154 18.1456 14.617 17.9716H21.677V5.37161H3.324V17.9706H10.383C10.383 18.3316 10.678 18.6246 11.043 18.6246L13.957 18.6256ZM24.5 17.9716V18.9286C24.5 19.5336 24.004 20.0246 23.394 20.0246H1.606C0.996 20.0246 0.5 19.5346 0.5 18.9286V17.9716H1.913V5.35661C1.913 4.59361 2.536 3.97461 3.307 3.97461H21.694C22.464 3.97461 23.088 4.59361 23.088 5.35661V17.9716H24.5Z"
              fill="#023047"
            />
          </g>
          <defs>
            <clipPath id="clip0_1354_14050">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      label: "Coach",
      description: "Mentor talent and amplify your professional influence.",
    },
    {
      icon: (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.463 1.0332C15.6292 1.36836 14.165 1.99658 13.6944 2.70378C13.6082 3.04269 13.601 3.33598 13.6306 3.65712C14.1283 3.77544 15.3443 3.94864 15.732 3.68384C16.3181 2.86259 16.4205 1.96212 16.463 1.0332ZM7.68731 4.36831C7.90373 4.88431 8.47064 5.9517 8.93812 6.15542C9.60361 6.1828 10.1407 5.97013 10.7104 5.68466C10.6959 5.38128 10.6528 5.08316 10.5081 4.79656C9.57323 4.31989 8.66663 4.30953 7.68731 4.36831ZM12.9872 4.35997C13.1415 4.98584 13.209 5.68559 13.2155 6.4122C12.7557 6.08042 12.1958 5.83456 11.555 5.6285C11.582 6.20291 11.6407 6.15303 11.177 6.39364C12.1187 6.68502 12.7749 7.03292 13.1825 7.52272C13.1024 8.75619 12.8902 9.99847 12.6653 11.0332C11.3052 11.0735 9.55861 11.2657 8.03916 11.576L9.5183 12.3155L6.57516 11.9374C5.84245 12.0586 4.79672 12.4584 4.70555 12.9469C4.92103 14.1498 6.86719 14.6884 7.81064 14.9362C9.68259 15.4202 12.0017 15.626 13.5887 15.5811C14.3387 15.5599 15.3164 15.4264 16.3198 15.2152L14.593 13.4693L17.4407 14.9486C18.5544 14.6154 19.735 14.2983 20.6858 13.636C20.8387 13.4996 21.2432 13.2448 21.167 13.0071C21.0736 12.7235 20.7662 12.4194 20.2378 12.1515C19.7093 11.8836 18.9885 11.662 18.1895 11.4947C16.9801 11.2413 15.5914 11.108 14.3755 11.0541L13.9393 13.2426C12.8018 14.2813 11.0812 13.6842 10.8523 12.7865L11.6876 12.6686C12.1006 13.124 12.7962 13.0459 13.1721 12.7763C13.2999 11.9308 13.5607 11.0038 13.7069 10.2273C14.6216 10.0759 15.3428 9.63242 15.9294 9.02173C15.6116 8.9293 15.5149 8.60656 15.4181 8.32555C14.992 8.79481 14.4414 9.2052 13.8568 9.34836C14.0907 7.80514 14.1924 6.08806 13.8988 4.57367C13.5907 4.52098 13.2873 4.44636 12.9872 4.35997ZM16.0966 7.35036C16.0214 8.11409 16.3965 8.3113 17.0865 8.41503C17.397 7.99058 17.4998 7.56598 17.5688 7.09175C17.1185 7.15442 16.4184 6.96477 16.0966 7.35036ZM16.0966 7.35036C16.0962 7.35045 16.0952 7.35153 16.0934 7.35402C16.0942 7.35294 16.0958 7.35148 16.0966 7.35036ZM21.1193 14.3616C20.1166 14.969 19.2195 15.3083 18.2075 15.6102L17.7124 17.7293L16.8412 15.968C15.6838 16.2315 14.5294 16.3985 13.6125 16.4244C11.9318 16.472 9.57689 16.2643 7.59951 15.7531C6.58978 15.4206 5.58708 15.1514 4.8135 14.5728L4.18936 19.1587L1.47656 21.9851C2.7975 21.8962 4.08816 22.51 5.20284 22.2476C5.679 22.1325 6.34027 21.8906 7.30462 21.4499L9.56461 19.5917L8.36583 21.5459C10.5735 22.5484 12.6587 22.1073 14.6217 21.2775L14.0109 17.9621L15.9294 21.025C18.029 22.7482 20.5268 23.3538 23.0129 22.7211C23.2204 22.6672 23.388 22.611 23.5285 22.5579L21.943 20.2628L20.9016 21.3842L21.4771 18.3449L21.1193 14.3616Z"
            fill="#023047"
          />
        </svg>
      ),
      label: "Fund",
      description: "Support high-potential freelancers and growing ventures.",
    },
  ];

  const handleSignUpProcess = (e) => {
    if (signupType == options[2]?.label) {
      goTo(e, coachPaths.CoachSignUpStep1);
    }
    return;
  };

  return (
    <AuthLayout>
      <div class="col-xxl-7 col-xl-6 col-lg-7 mb-4 mb-lg-0 mx-auto">
        <div class="ct_signup_right_content bg-white ct_custom_scroll pe-lg-5 pe-3">
          <div class="ct_signup_logo ct_mb_60">
            <img src="assets/img/Nuvio_logo.png" alt="" />
          </div>
          <div class="mt-0 text-center">
            <h2 class="ct_fs_32 mb-3 ct_darkblue_text">
              How do you plan to use
              <span class="ct_yellow_text"> Nuvio?</span>
            </h2>
            <p
              class="mb-0 ct_darkblue_text mx-auto"
              style={{ maxWidth: "480px" }}
            >
              We’ll tailor your experience whether you’re here to find Jobs,
              Hire Talent, Offer Coaching, or Invest in promising ventures.
            </p>
          </div>
          <div class="row pt-5">
            {options?.map((item, index) => (
              <div
                class={`col-lg-3 col-md-6 col-sm-6 mb-4 mb-lg-0 `}
                onClick={() => {
                  setSignUpType(item?.label);
                }}
              >
                <a
                  class={`ct_choose_signup_option_card ${
                    item?.label == signupType ? "active" : ""
                  }`}
                >
                  {item?.icon}
                  <h4 class="ct_fs_16 ct_fw_600 mt-3">{item?.label}</h4>
                  <p class="ct_fs_12 mb-0">{item?.description}</p>
                </a>
              </div>
            ))}
          </div>

          <div class="text-center mt-5">
            <a
              onClick={(e) => handleSignUpProcess(e)}
              class="ct_yellow_btn w-75 mx-auto"
            >
              Proceed to Sign Up
            </a>
          </div>
          <div class="ct_back_login_text text-center mt-3">
            <a
              onClick={(e) => goTo(e, coachPaths.Login)}
              class="mb-0 ct_darkblue_text"
            >
              <i class="fa-solid fa-arrow-left"></i> Back to Log In
            </a>
          </div>

          <StepsDots activeStep={1} />
        </div>
      </div>
    </AuthLayout>
  );
};

export default Signup;
